/*
 * outlet-schedule.js
 * 出張アウトレット特設テンプレートの時刻状態機械。
 *
 * スケジュールは outlet-drop-nav が出力する <script type="application/json" data-outlet-schedule>
 * が唯一の出所。hero / countdown / drop-nav はここが発火する CustomEvent('outlet:phase') を購読する。
 * 各セクションで時刻計算を持たせるとフェーズ境界でズレるため、計算はこのファイルに閉じる。
 *
 * CDN キャッシュで Liquid の now が固まるため、サーバ時刻には一切依存しない。
 * 会期は JST 固定オフセットで絶対時刻に解決し、閲覧者のタイムゾーン設定にも依存させない。
 */
(function () {
  'use strict';

  if (window.__outletSchedule) return;

  var EVENT = 'outlet:phase';
  var DAY_MS = 86400000;

  function parseJst(raw, offset) {
    if (!raw) return NaN;
    var normalized = String(raw).trim().replace(' ', 'T');
    if (normalized.length === 16) normalized += ':00';
    return Date.parse(normalized + offset);
  }

  /* JST 上の暦日。同日判定に使う（ローカルタイムゾーンでは判定できない） */
  function jstDayIndex(ms) {
    return Math.floor((ms + 9 * 3600000) / DAY_MS);
  }

  function readSchedule() {
    var el = document.querySelector('[data-outlet-schedule]');
    if (!el) return null;
    var raw;
    try {
      raw = JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
    var offset = raw.offset || '+09:00';
    var drops = (raw.drops || [])
      .map(function (d) {
        return {
          key: d.key,
          label: d.label,
          url: d.url,
          count: d.count,
          openAt: parseJst(d.openAt, offset)
        };
      })
      .filter(function (d) {
        return !isNaN(d.openAt);
      })
      .sort(function (a, b) {
        return a.openAt - b.openAt;
      });

    if (!drops.length) return null;

    return { drops: drops, closeAt: parseJst(raw.closeAt, offset) };
  }

  function evaluate(schedule, now) {
    var closed = !isNaN(schedule.closeAt) && now >= schedule.closeAt;
    var opened = 0;
    var nextDrop = null;

    var drops = schedule.drops.map(function (d) {
      var state;
      if (closed) {
        state = 'closed';
      } else if (now >= d.openAt) {
        state = 'open';
        opened += 1;
      } else {
        state = jstDayIndex(now) === jstDayIndex(d.openAt) ? 'today' : 'upcoming';
        if (!nextDrop) nextDrop = d;
      }
      return { key: d.key, label: d.label, state: state, openAt: d.openAt };
    });

    var phase;
    if (closed) phase = 'closed';
    else if (opened === 0) phase = 'pre';
    else if (!nextDrop && jstDayIndex(now) === jstDayIndex(schedule.closeAt)) phase = 'final';
    else phase = 'live';

    /* カウントダウンの標的。次の弾が無ければ会期終了。 */
    var boundary = nextDrop ? nextDrop.openAt : schedule.closeAt;
    var boundaryKind = nextDrop ? 'drop' : 'close';
    if (closed) {
      boundary = NaN;
      boundaryKind = null;
    }

    return {
      phase: phase,
      opened: opened,
      total: drops.length,
      drops: drops,
      nextLabel: nextDrop ? nextDrop.label : null,
      boundary: boundary,
      boundaryKind: boundaryKind
    };
  }

  var schedule = null;
  var timer = null;
  var state = null;

  function publish() {
    schedule = schedule || readSchedule();
    if (!schedule) return;

    state = evaluate(schedule, Date.now());
    document.documentElement.setAttribute('data-outlet-phase', state.phase);
    document.dispatchEvent(new CustomEvent(EVENT, { detail: state }));

    /* 1秒ポーリングではなく次の境界ちょうどに1回だけ起こす */
    if (timer) clearTimeout(timer);
    if (!isNaN(state.boundary)) {
      var wait = state.boundary - Date.now() + 500;
      /* setTimeout は約24.8日で溢れるので上限を切る */
      timer = setTimeout(publish, Math.min(Math.max(wait, 1000), 3600000));
    }
  }

  /* タブを離れている間に境界をまたぐと表示が古いままになるため復帰時に再計算 */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) publish();
  });

  window.__outletSchedule = {
    refresh: publish,
    /* 後から DOM に入るセクションが現在値を取れるように */
    get current() {
      return state;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', publish);
  } else {
    publish();
  }
})();
